import { render } from "./SettingCardControl.vue?vue&type=template&id=b503715a&scoped=true"
import script from "./SettingCardControl.vue?vue&type=script&lang=js"
export * from "./SettingCardControl.vue?vue&type=script&lang=js"

import "./SettingCardControl.vue?vue&type=style&index=0&id=b503715a&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b503715a"]])

export default __exports__